import React, { useMemo } from "react";
import {
  GetHaberesVariablesComments,
  CreateHaberesVariablesComment,
} from "src/graphql/haberesVariablesComments";
import RepositoryCommentsTab from "src/components/repositorio/RepositoryCommentsTab";

/**
 * Wrapper lazy: carga comentarios (companyId + period) y reutiliza RepositoryCommentsTab.
 * onCommentCreatedCallback: opcional, para refrescar el badge del rail al crear.
 */
const HaberesVariablesCommentsTab = ({
  editData,
  companyIdOverride,
  onCommentCreatedCallback,
}) => {
  const companyId = editData?.companyId || companyIdOverride;
  const period = editData?.period;

  const { data: commentsData } = GetHaberesVariablesComments({
    companyId,
    period,
    pause: !companyId || !period,
  });

  const createComment = CreateHaberesVariablesComment();

  const comments = useMemo(
    () => commentsData?.getHaberesVariablesComments || [],
    [commentsData]
  );

  const data = useMemo(
    () => ({
      id: `${companyId}-${period}`,
      companyId,
      innerComments: comments,
    }),
    [companyId, period, comments]
  );

  const onCommentCreated = async (input) => {
    const { error } = await createComment.executeMutation({
      companyId,
      period,
      comment: input.comment,
    });
    if (error) throw error;
    if (typeof onCommentCreatedCallback === "function") {
      onCommentCreatedCallback();
    }
  };

  return (
    <RepositoryCommentsTab
      data={data}
      companyIdOverride={companyIdOverride}
      onCommentCreated={onCommentCreated}
      submitLoading={createComment.fetching}
    />
  );
};

export default HaberesVariablesCommentsTab;
